<template>
  <div
    v-if="activeDialog"
    class="overlay"
    :class="activeDialog ? 'active': ''"
  >
    <div
      id="dialoge_close"
      class="common-dialog-wrapper"
      :class="customClass"
      :style="{ maxWidth: width + 'px' }"
    >
      <div v-if="closable" class="close-dialog" @click="closePopups">
        <GreyCloseIcon20 />
      </div>
      <slot />
      <button
        v-if="showFooter"
        id="dialoge_continue"
        class="btn dialog-btn"
        @click="closePopups"
      >
        <span class="dialog-btn-text">{{ btnName }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import GreyCloseIcon20 from '@/components/icons/GreyCloseIcon20.vue';

export default {
  name: 'CommonDialog',
  components: {GreyCloseIcon20},
  props: {
    showFooter: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    width: {
      type: String,
    },
    btnName: {
      type: String,
      default: 'Continue'
    }
  },
  emits: ['closed'],
  data() {
    return {
      activeDialog: false,
    };
  },
  methods: {
    openPopups() {
      this.activeDialog = true;
    },
    closePopups() {
      this.activeDialog = false;
      this.$emit('closed');
    },
  }
};
</script>

<style>
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay.active {
  animation: show .3s linear;
}

.common-dialog-wrapper {
  width: 100%;
  max-width: 440px;
  border: 1px solid #D7DCE6;
  box-sizing: border-box;
  border-radius: 30px;
  padding: 40px 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  gap: 24px;
}

.close-dialog {
  width: 70px;
  height: 70px;
  padding: 23px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.close-dialog svg {
  width: 100%;
  height: 100%;
}

.close-dialog svg path {
  transition: .5s all;
}

.close-dialog:hover svg path {
  fill: var(--accent-color);
}

.close-dialog img {
  display: block;
  width: 100%;
}

.common-dialog-wrapper .dialog-btn {
  min-width: 140px;
  width: 100%;
  max-width: 140px;
  padding: 13px 12px;
  background-color: var(--white-color);
  border-color: var(--accent-color);
}

.common-dialog-wrapper .dialog-btn:hover {
  background-color: var(--accent-color);
  border-color: var(--accent-color);
}

.common-dialog-wrapper .dialog-btn:hover .dialog-btn-text {
  color: var(--white-color);
}

.dialog-btn-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: var(--accent-color);
  transition: .5s all;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}

/*custom classes */
.common-dialog-wrapper.assign-success {
  width: 100%;
  max-width: 588px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.feedback-widget-icon {
  z-index: 1;
}
</style>
